
function Bookings() {
    return (
        <div className="sidebar-inner">
            <h2>Bookings</h2>
        </div>
    )
}

export default Bookings
